<div [class.is-filtered]="isFiltered">
  <mat-form-field>
    <mat-label>Filter</mat-label>
    <input [formControl]="element" matInput type="text">
  </mat-form-field>
  <button (click)="clearFilterButton()" [class.show]="isFiltered" mat-icon-button type="button">
    <mat-icon>clear</mat-icon>
  </button>
</div>
